const serverConfig = {
  baseURL: 'https://api.jingchengxinyong.cn'
}
export default serverConfig
